import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import {
  duplicateQuotaEndpoint,
  saveQuotaEndpoint,
  submitQuotaEndpoint,
  submitQuotaWithNumberEndpoint,
} from '../../../common/endpoints';

export const saveQuotaMaintenance = createApi(saveQuotaEndpoint, 'POST');
export const duplicateQuotaMaintenance = createApi(duplicateQuotaEndpoint, 'POST');
export const submitQuotaMaintenance = createApi(submitQuotaEndpoint, 'POST');
export const submitQuotaWithNumber = createApi(submitQuotaWithNumberEndpoint, 'PATCH');

const SaveQuota = createSlice({
  name: 'SaveQuota',
  initialState: {
    data: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveQuotaMaintenance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveQuotaMaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(saveQuotaMaintenance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(duplicateQuotaMaintenance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(duplicateQuotaMaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(duplicateQuotaMaintenance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(submitQuotaMaintenance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitQuotaMaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(submitQuotaMaintenance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(submitQuotaWithNumber.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitQuotaWithNumber.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(submitQuotaWithNumber.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SaveQuota.reducer;